export default __webpack_public_path__ + "static/media/recipe.74a3ee15.svg";